import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getIsLoading, getSummary, getSkillMatrix, getSuggestions } from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { getCollaboratorSkillsRankingAction } from "../actions";

const useCollaboratorSkillsRanking = () => {

  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const summary = useSelector(getSummary);
  const skillMatrix = useSelector(getSkillMatrix);
  const suggestions = useSelector(getSuggestions);

  useEffect(() => {
    dispatch(getCollaboratorSkillsRankingAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const formattedSummary = useMemo(() => {
    return summary.map((row) => {
      return ({
        ...row,
        indicator: row.gap,
        result: row.gap,
      })
    })
  }, [summary])

  const skillMatrixColumnDef = useMemo(() => {
    if (!skillMatrix?.skills?.length) return [];

    const skillColumns = skillMatrix.skills.map((skill) => {
      return ({
        headerName: skill,
        field: skill,
        filter: "agSetColumnFilter",
        comparator: numberComparatorMax2,
        filterParams: numberFilterParams(),
        chartDataType: "series",
        cellClass: "currencyValue",
        valueFormatter: createNumberFormatter(0, 0),
        enableValue: true,
        allowedAggFuncs: ["sum", "min", "max", "avg"],
        cellRenderer: "PieRenderer",
      })
    })

    return [
      {
        headerName: getLocalizedString("code"),
        field: "userCode",
        filter: "agTextColumnFilter",
        checkboxSelection: function (params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
        headerCheckboxSelection: function (params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
        headerCheckboxSelectionFilteredOnly: true,
      },
      {
        headerName: getLocalizedString("nameAndSurname"),
        field: "userName",
        filter: "agTextColumnFilter",
      },
      ...skillColumns,
    ];
  }, [skillMatrix])

  return {
    isLoading,
    summary: formattedSummary,
    skillMatrixColumnDef,
    skillMatrix,
    suggestions,
  }
}

export default useCollaboratorSkillsRanking;